import { Angle, BaseTexture, Color3, Mesh, Quaternion, Scene, SceneLoader, Sound, StandardMaterial, Texture, Vector3 } from "@babylonjs/core"
import '@babylonjs/loaders/OBJ/objFileLoader';
import { BoostSFX } from "../../core/Sounds";
import doorWooshSfx from "../../sfx/woosh.wav"
import doorHitSfx from "../../sfx/hit.wav"
import doorErrorSfx from "../../sfx/error.wav"
import doorSuccessSfx from "../../sfx/success.wav"

let _doorMeshRed: Mesh | null = null;
let _doorMeshBlue: Mesh | null = null;
let _activatedDoorMat: StandardMaterial | null = null;
let _failedDoorMat: StandardMaterial | null = null;
let _finishDoorMat: StandardMaterial | null = null;
let _windSound: Sound | null = null;
let _hitSound: Sound | null = null;
let _errorSound: Sound | null = null;
let _successSound: Sound | null = null;
export class Door {
  index: number
  localPosition: Vector3
  rootMesh: Mesh | null = null
  shouldGoLeft: boolean

  activatedDoorMat: StandardMaterial;
  failedDoorMat: StandardMaterial;
  finishDoorMat: StandardMaterial;
  flagMesh: Mesh | null = null;

  activated = false

  constructor(scene: Scene, index: number, position: Vector3, shouldGoLeft: boolean) {
    this.shouldGoLeft = shouldGoLeft
    this.localPosition = position;
    this.index = index;
    // this.mesh = MeshBuilder.CreateBox("door", { size: 4 }, scene);

    if (_activatedDoorMat == null) {
      _activatedDoorMat = new StandardMaterial("activatedDoorMat");
      _activatedDoorMat.diffuseColor = Color3.Green();
    }
    this.activatedDoorMat = _activatedDoorMat;

    if (_failedDoorMat == null) {
      _failedDoorMat = new StandardMaterial("failedDoorMat");
      _failedDoorMat.diffuseColor = Color3.Black();
    }
    this.failedDoorMat = _failedDoorMat;

    if (_finishDoorMat == null) {
      _finishDoorMat = new StandardMaterial("finishDoorMat");
      _finishDoorMat.disableLighting = true;
      _finishDoorMat.emissiveTexture = new Texture("./textures/damier.gif", scene, false, false);
      (_finishDoorMat.emissiveTexture as Texture).uScale = 0.4;
      (_finishDoorMat.emissiveTexture as Texture).vScale = 0.3;
    }
    this.finishDoorMat = _finishDoorMat;

    if (_windSound == null) {
      _windSound = new Sound("doorWooshSfx", doorWooshSfx, scene);
      _windSound.loop = false;
    }

    if (_hitSound == null) {
      _hitSound = new Sound("doorHitSfx", doorHitSfx, scene);
      _hitSound.loop = false;
    }

    if (_errorSound == null) {
      _errorSound = new Sound("doorErrorSfx", doorErrorSfx, scene);
      _errorSound.loop = false;
    }

    if (_successSound == null) {
      _successSound = new Sound("doorSuccessSfx", doorSuccessSfx, scene);
      _successSound.loop = false;
    }

  }

  async init(scene: Scene) {
    if (_doorMeshRed == null) {
      _doorMeshRed = (await SceneLoader.ImportMeshAsync("", "./models/", "flag_red.glb", scene)).meshes[0] as Mesh;
      _doorMeshRed.name = "_doorRed";
      _doorMeshRed.isVisible = false;
      _doorMeshRed.getChildMeshes().forEach(mesh => mesh.isVisible = false);
    }
    if (_doorMeshBlue == null) {
      _doorMeshBlue = (await SceneLoader.ImportMeshAsync("", "./models/", "flag_blue.glb", scene)).meshes[0] as Mesh;
      _doorMeshBlue.name = "_doorBlue";
      _doorMeshBlue.isVisible = false;
      _doorMeshBlue.getChildMeshes().forEach(mesh => mesh.isVisible = false);
    }
    this.rootMesh = (this.shouldGoLeft ? _doorMeshBlue : _doorMeshRed).clone("door" + this.index.toString().padStart(3, '0'));
    this.rootMesh.getChildMeshes().forEach(mesh => mesh.isVisible = true);
    this.flagMesh = this.rootMesh.getChildren()[0]?.getChildren()[0] as Mesh;
    // this.rootMesh.rotationQuaternion = Quaternion.RotationYawPitchRoll(90, 0, 0);
    // this.rootMesh.rotation = Quaternion.RotationAxis(this.rootMesh.right, Angle.FromDegrees(45).radians()).toEulerAngles();
    this.rootMesh.rotate(this.rootMesh.right, Angle.FromDegrees(-35).radians())
    this.rootMesh.rotate(this.rootMesh.up, Angle.FromDegrees(90).radians())
    this.rootMesh.position = this.localPosition;
  }

  setFailed() {
    this.activated = false;
    if (this.flagMesh) this.flagMesh.material = this.failedDoorMat;
    _errorSound?.setVolume(0.5);
    _errorSound?.play();
  }
  setActivated() {
    if (!this.activated) {
      this.activated = true;
      if (this.flagMesh) this.flagMesh.material = this.activatedDoorMat;
      // _successSound?.setVolume(0.2);
      // _successSound?.play();
    }
  }

  _playSfx(playerDistance: number, playerSpeed: number) {
    if (Math.abs(playerDistance) < 10 && Math.abs(playerDistance) > 2) {
      _windSound?.setVolume(Math.min(Math.abs((5 / playerDistance) * (playerSpeed / 100)), 1))
      _windSound?.play()
    }
    if (Math.abs(playerDistance) < 2.5) {
      _hitSound?.setVolume(Math.min(Math.abs((10 / playerDistance) * (playerSpeed / 100)), 2))
      _hitSound?.play()
      this.rootMesh?.rotate(this.rootMesh.forward, Angle.FromDegrees(Math.max(Math.min(10 / playerDistance, 30), -30)).radians())
    }
  }
  setFinishMaterial() {
    if (this.flagMesh) this.flagMesh.material = this.finishDoorMat;
  }
}